import { useMutation } from 'react-query';
import { cancelDemand } from 'src/services/api/demands';

function useCancelDemand() {
  return useMutation((demand) => cancelDemand(demand));
}

export default useCancelDemand;
